import { ApolloClient } from '@apollo/client'
import createFetchSaga from '@utils/store/createFetchSaga'
import internalStockChangesGetQuery from '@queries/internalStockChangesGetQuery'
import { actionTypes } from './index'
import { sagaDebounce } from '@store/helpers'

const fetchList = async (client: ApolloClient<any>, action: Action): Promise<any> => {
  return await client
    .query({ query: internalStockChangesGetQuery, variables: { ...action.payload, nested: true } })
    .then(({ data }) => ({ data: data?.internalStockChangesGet }))
}

export default function* watch(): Generator {
  if (typeof window === 'undefined') return
  yield sagaDebounce(200, actionTypes.run, createFetchSaga(actionTypes.run, fetchList))
}
